import { connect } from 'react-redux'
import OAFeeDetails from '../views/OAFeeDetails'
import { 
  listRevenue, getUnionsFee, getGamesFee, getMembershipData, getUnionMembership
} from '../action/userAction'

function mapStateToProps(state) {
  return {
    revenue: state.getIn(['data', 'revenue']),
    unions_col: state.getIn(['data', 'unions_col']),
    unions_fee: state.getIn(['data', 'unions_fee']),
    games_col: state.getIn(['data', 'games_col']),
    games_fee: state.getIn(['data', 'games_fee']),
    main_club: state.getIn(['data', 'main_club']),
    union_membership_amount: state.getIn(['data', 'union_membership_amount']),
    membership_header: state.getIn(['data', 'membership_header']),
    membership_sum: state.getIn(['data', 'membership_sum']),
    user: state.getIn(['data', 'user']),
  };
}

const mapDispatchToProps = (dispatch) => ({
  onLoad: () => {
    dispatch(listRevenue());
  },
  getUnionsFee: () => {
    dispatch(getUnionsFee());
  },
  getGamesFee: () => {
    dispatch(getGamesFee());
  },
  getMembershipData: () => {
    dispatch(getMembershipData());
  },
  getUnionMembership: () => {
    dispatch(getUnionMembership());
  },
})

const OAFeeDetailsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(OAFeeDetails)

export default OAFeeDetailsContainer


